/* eslint-disable no-param-reassign */

import Vue from 'vue';
import { captureEvent } from '@sentry/browser';

let current = null;
const uploadNext = async (store) => {
    const uploads = Array.from(store.getters.pendingUploads);

    if (current) {
        return;
    }

    if (!uploads.length) {
        store.commit('notifications/pop', store.state.notificationId, { root: true });
        return;
    }

    current = uploads.pop();

    try {
        const form = new FormData();
        form.append('filedata', current.blob, current.file.name);
        const response = await Vue.http.post('images/sourceimages', form, {
            uploadProgress: (progress) => {
                store.commit('setProgress', {
                    id: current.id,
                    progress,
                });
            },
        });

        if (response.body.error) {
            throw response;
        }

        current.model.sync({
            [current.property]: response.body.items[0].hash,
        });
    } catch (response) {
        store.commit('setError', { id: current.id, error: response.body.error });

        store.dispatch('notifications/add', {
            color: 'danger',
            title: 'Fehler beim Upload',
            description: `Die Datei "${current.file.name}" konnte nicht hochgeladen werden.`,
            image: '/images/upload.svg',
        }, { root: true });

        captureEvent({
            message: 'Fehler beim Dateiupload',
            extra: {
                response,
            },
        });
    }

    store.commit('markComplete', current.id);
    current = null;
    uploadNext(store);
};

export default {
    namespaced: true,

    state: {
        notificationId: null,
        uploads: [],
    },

    getters: {
        pendingUploads: state => state.uploads.filter(u => !u.complete),
    },

    mutations: {
        push(state, upload) {
            state.uploads = [upload].concat(state.uploads);
        },

        setProgress(state, { id, progress }) {
            state.uploads = state.uploads.map((upload) => {
                if (upload.id === id) {
                    upload.progress = progress;
                }

                return upload;
            });
        },

        setError(state, { id, error }) {
            state.uploads = state.uploads.map((upload) => {
                if (upload.id === id) {
                    upload.error = error;
                }

                return upload;
            });
        },

        markComplete(state, id) {
            state.uploads = state.uploads.map((upload) => {
                if (upload.id === id) {
                    upload.complete = true;
                }

                return upload;
            });
        },

        clearComplete(state) {
            state.uploads = state.uploads.filter(item => !item.complete);
        },

        setNotificationId(state, id) {
            state.notificationId = id;
        },
    },

    actions: {
        async add(store, upload) {
            const data = upload;

            data.id = Date.now();
            data.added = Date.now();
            data.complete = false;

            store.commit('push', data);

            if (!store.state.notificationId || !store.rootGetters['notifications/hasId'](store.state.notificationId)) {
                const notificationId = await store.dispatch('notifications/add', {
                    title: 'Dateien hochladen …',
                    description: 'Ihre Dateien werden hochgeladen, schliessen Sie nicht das Browserfenster.',
                    timeout: 0,
                    color: 'dark',
                    image: '/images/upload.svg',
                }, { root: true });

                store.commit('setNotificationId', notificationId);
            }

            uploadNext(store);
        },
    },
};
